import { IonSegment, IonSegmentButton, IonLabel, isPlatform } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setSegmentSelected } from "../../../store/documentShow";
import { selectSegmentSelected } from "../../../store/documentShow/selectors/selectSegmentSelected";
import { DocumentHistory } from "./DocumentHistory";
import { DocumentInfo } from "./DocumentInfo";
import { DocumentSigners } from "./DocumentSigners";

export const SegmentsSection = () => {
  const dispatch = useDispatch();
  const segmentSelected = useSelector(selectSegmentSelected);
  return (
    <>
      <IonSegment
        onIonChange={(e) => {
          dispatch(setSegmentSelected(e.detail.value || ""));
        }}
        value={segmentSelected}
        color="primary"
        style={{ maxWidth: "500px" }}
      >
        <IonSegmentButton value="info">
          <IonLabel>Documento</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton value="signers">
          <IonLabel>Firmantes</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton value="history">
          <IonLabel>Historial</IonLabel>
        </IonSegmentButton>
      </IonSegment>

      <section
        style={{ maxWidth: "1000px" }}
        className={isPlatform("desktop") ? "ion-margin-top" : ""}
      >
        {segmentSelected === "info" && <DocumentInfo />}
        {segmentSelected === "signers" && <DocumentSigners />}
        {segmentSelected === "history" && <DocumentHistory />}
      </section>
    </>
  );
};
